export enum VolleyballEventDetailId {
  SetsNumber = 7,
  PossibleGoldenSet = 61,
  ScoringSystem = 158,
}
